module.exports = __webpack_public_path__ + "static/lightning-combobox-35403079a9ab7448fb70f8e6f12667b4.png";